import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import OverviewHeader from '../../header/overview-header';
import { TabFilter } from '../../tab-filter/tab-filter.component';
import { SpotOverview } from '../spot-overview/spot-overview.component';
import { LayoutTable } from './layout-table/layout-table.component';
import { useLayout } from './layout.controller';

export const Layout = () => {
    const viewProps = useLayout();
    return (
        <div className='bg-background-default inline-flex w-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                title={
                    <div className='flex gap-2'>
                        <span>{CommonMessage.OBJECTS.SPOT.DISTRI_SPOTS}</span>
                        <span>/</span>
                        <span>
                            <FormattedMessage
                                id='spots.contents.title'
                                defaultMessage='Contents'
                            />
                        </span>
                    </div>
                }
            />
            <div className='flex w-full flex-1 flex-col items-start gap-4'>
                <TabFilter
                    keys={['layout', 'table']}
                    displayMap={
                        new Map([
                            [
                                'layout',
                                <FormattedMessage
                                    key='spots.contents.tab.layout'
                                    id='spots.contents.tab.layout'
                                    defaultMessage='Layout view'
                                />
                            ],
                            [
                                'table',
                                <FormattedMessage
                                    key='spots.contents.tab.table'
                                    id='spots.contents.tab.table'
                                    defaultMessage='Table view'
                                />
                            ]
                        ])
                    }
                    onChange={viewProps.handleTabChange}
                    defaultActive='layout'
                />
                {viewProps.activeTab === 'layout' ? <SpotOverview /> : <LayoutTable />}
            </div>
        </div>
    );
};
